import React, { Fragment } from 'react'
import { Breadcrumbs, UL } from '../../../AbstractElements';
import DataGridView from './DataGridView';
import { Container } from 'reactstrap';

// The tenant/date summary view - datamode-agnostic, since it reads the same
// SalesTransaction header collection regardless of itemwise/invoicewise. The
// item-level and invoice-level detail grids are separate pages (Item Grid / Invoice Grid).
const DataGrid = () => {
    // The "Live" suffix only disambiguates from the UAT grid, which only Backend
    // Users can see - everyone else just gets the plain name.
    const isBackendUser = localStorage.getItem("usertype") === "Backend User";
    const pageTitle = isBackendUser ? "Data Grid - Live" : "Data Grid";
    return (
        <UL attrUL={{ className: 'simple-list nav-menus flex-row' }}>
            <Fragment>
                <Breadcrumbs parent={pageTitle} title={pageTitle} mainTitle={pageTitle} />
                <Container fluid={true}>
                    <DataGridView />
                </Container>
            </Fragment>
        </UL>
    )
}

export default DataGrid
